import { FC } from 'react';

import { ICustomRadioSelectorProps } from './types';

import { Container, OptionsWrapper } from './styles';

import { Label } from '../Label';
import { ErrorMessage } from '../ErrorMessage';
import { CustomRadioLoading } from '../CustomRadioLoading';
import { CustomRadio } from '../CustomRadio';

export const CustomRadioSelector: FC<ICustomRadioSelectorProps<any>> = ({
  label,
  error,
  hasError: _hasError = false,
  options,
  value,
  onChange,
  direction = 'row',
  isLoading = false,
}) => {
  const hasError = !!error || _hasError;

  return (
    <Container>
      {!!label && <Label mb="xxs">{label}</Label>}

      <OptionsWrapper direction={direction}>
        {isLoading ? (
          <>
            <CustomRadioLoading />
            <CustomRadioLoading />
          </>
        ) : (
          options.map((option, index) => (
            <CustomRadio
              key={String(`${option.title}-${index}`)}
              title={option.title}
              description={option.description}
              hasError={hasError}
              icon={option.icon}
              onClick={() => onChange(option.value)}
              checked={value === option.value}
            />
          ))
        )}
      </OptionsWrapper>

      <ErrorMessage mt="xxs">{error}</ErrorMessage>
    </Container>
  );
};
